import React from "react";
let connect = require("react-redux").connect;

let actions = require("../actions/actions");

class ModerationIconCard extends React.Component {
    addToFeatured(featuredItem, e) {
        e.stopPropagation();
        switch (featuredItem) {
            case "icon":
                this.props.icon.feature_icon
                    ? this.props.unFeatureIcon("upload", this.props.icon.id)
                    : this.props.featureIcon("upload", this.props.icon.id);
                break;
            case "collection":
                // if there is not a collection just disable this button
                if (!this.props.icon.collection.id) {
                    return;
                }

                this.props.icon.feature_collection
                    ? this.props.unFeatureCollection(this.props.icon.id)
                    : this.props.featureCollection(this.props.icon.id);
                break;
        }
    }

    checkCardStatus(icon) {
        let cardClass;

        switch (true) {
            case icon.selected:
                cardClass = "active ui_check-mark";
                break;
            case icon.status === "approved":
                cardClass = "disabled approved";
                break;
            case icon.status === "denied":
                cardClass = "disabled denied";
                break;
        }

        return cardClass;
    }

    clickCard(icon, e) {
        if (!icon.selected) {
            this.props.selectIcon(icon.id);
        } else {
            this.props.deselectIcon(icon.id);
        }
    }

    clearTagInput(icon, e) {
        if (!icon.selected) {
            this.refs[e.target.name].select();
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            overlay: false
        };
    }

    dismissOverlay() {
        this.setState({
            overlay: false
        });
    }

    expandIcon(icon, e) {
        if (!icon.selected) {
            e.stopPropagation();

            this.setState({
                overlay: true
            });
        }
    }

    goToCollection(icon, e) {
        if (icon.selected) {
            e.preventDefault();
        }
    }

    render() {
        let collectionLink = null,
            icon = this.props.icon,
            license,
            statusClass = this.checkCardStatus(icon);

        if (this.state.overlay) {
            return (
                <div
                    className="icon-overlay"
                    onClick={this.dismissOverlay.bind(this)}
                >
                    <img
                        src={icon.url}
                        onClick={this.dismissOverlay.bind(this)}
                    />
                </div>
            );
        }

        if (icon.license_description === "public-domain") {
            license = (
                <a
                    tabIndex="-1"
                    className="icon-license"
                    href="#"
                    onClick={e => {
                        e.preventDefault();
                    }}
                    target="_blank"
                >
                    <i className="ui_public-domain" /> Public Domain
                </a>
            );
        } else {
            license = (
                <a
                    tabIndex="-1"
                    className="icon-license"
                    href="#"
                    onClick={e => {
                        e.preventDefault();
                    }}
                    target="_blank"
                >
                    <i className="ui_cc" /> Creative Commons
                </a>
            );
        }

        if (icon.collection.permalink) {
            collectionLink = (
                <a
                    href={icon.collection.permalink}
                    onClick={this.goToCollection.bind(this, icon)}
                    target="_blank"
                    className="collection-link ellipsis"
                >
                    {`${icon.collection.name} Collection`}
                </a>
            );
        }

        return (
            <div
                className={`card-view ${statusClass}`}
                style={{
                    width: "442px",
                    margin: "8px",
                    background: "#FFFFFF",
                    overflow: "hidden"
                }}
                onClick={this.clickCard.bind(this, icon)}
            >
                <div className="icon-card">
                    <div className="icon-view">
                        <img src={icon.url} />
                        <span
                            className={`
                            icon-license
                            ${
                                icon.license_description === "public-domain"
                                    ? "ui_public-domain"
                                    : "ui_cc"
                            }
                            `}
                        >
                            {collectionLink}
                        </span>
                    </div>
                    <div
                        className={`meta ${
                            this.props.preview ? "disabled" : ""
                        }`}
                    >
                        <form action="./" onClick={this.stopCardClick}>
                            <label
                                htmlFor="icon-name"
                                className="#f0f0f0 display-flex"
                            >
                                Name
                                <span style={{ color: "#cdcdcd" }}>
                                    upload id: {icon.id}
                                </span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="icon-name"
                                defaultValue={icon.name}
                                onKeyUp={this.saveName.bind(this)}
                                onChange={this.saveName.bind(this)}
                                ref={`icon${icon.id}-name`}
                                name={`icon${icon.id}-name`}
                                placeholder="Give it a name"
                            />
                            <div className="tags">
                                <label
                                    htmlFor="icon-tag-new"
                                    className="#f0f0f0"
                                >
                                    Tags
                                </label>

                                <div className="tag-contianer">
                                    <input
                                        type="text"
                                        placeholder="Add first tag"
                                        className="form-control"
                                        id={`icon-tag-1`}
                                        ref={0}
                                        onClick={this.clearTagInput.bind(
                                            this,
                                            icon
                                        )}
                                        onKeyUp={this.saveTag.bind(this)}
                                        onChange={this.saveTag.bind(this)}
                                        name={0}
                                        defaultValue={icon.tags[0]}
                                        value={icon.tags[0]}
                                    />
                                </div>
                                <div className="tag-contianer">
                                    <input
                                        type="text"
                                        placeholder="Add second tag"
                                        className="form-control"
                                        id={`icon-tag-2`}
                                        ref={1}
                                        onClick={this.clearTagInput.bind(
                                            this,
                                            icon
                                        )}
                                        onKeyUp={this.saveTag.bind(this)}
                                        onChange={this.saveTag.bind(this)}
                                        name={1}
                                        defaultValue={icon.tags[1]}
                                        value={icon.tags[1]}
                                    />
                                </div>
                                <div className="tag-contianer">
                                    <input
                                        type="text"
                                        placeholder="Add third tag"
                                        className="form-control"
                                        id={`icon-tag-3`}
                                        ref={2}
                                        onClick={this.clearTagInput.bind(
                                            this,
                                            icon
                                        )}
                                        onKeyUp={this.saveTag.bind(this)}
                                        onChange={this.saveTag.bind(this)}
                                        name={2}
                                        defaultValue={icon.tags[2]}
                                        value={icon.tags[2]}
                                    />
                                </div>
                                <div className="tag-contianer">
                                    <input
                                        type="text"
                                        placeholder="Add fourth tag"
                                        className="form-control"
                                        id={`icon-tag-4`}
                                        ref={3}
                                        onClick={this.clearTagInput.bind(
                                            this,
                                            icon
                                        )}
                                        onKeyUp={this.saveTag.bind(this)}
                                        onChange={this.saveTag.bind(this)}
                                        name={3}
                                        defaultValue={icon.tags[3]}
                                        value={icon.tags[3]}
                                    />
                                </div>
                                <div className="tag-contianer">
                                    <input
                                        type="text"
                                        placeholder="Add fifth tag"
                                        className="form-control"
                                        id={`icon-tag-5`}
                                        ref={4}
                                        onClick={this.clearTagInput.bind(
                                            this,
                                            icon
                                        )}
                                        onKeyUp={this.saveTag.bind(this)}
                                        onChange={this.saveTag.bind(this)}
                                        name={4}
                                        defaultValue={icon.tags[4]}
                                        value={icon.tags[4]}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div
                    style={{
                        display: "flex"
                    }}
                >
                    <button
                        type="button"
                        className="btn btn-default black zoom"
                        style={{
                            width: "245px",
                            borderRadius: "0"
                        }}
                        onClick={this.expandIcon.bind(this, icon)}
                    >
                        <svg viewBox="0 0 100 100" width="42" height="42">
                            <use x="0" y="0" xlinkHref="#zoom_in.svg" />
                        </svg>
                    </button>
                    <button
                        type="button"
                        style={{
                            width: "100px",
                            borderRadius: "0"
                        }}
                        className={`btn btn-default featured-item featured-icon ${
                            this.props.icon.feature_icon ? "active" : ""
                        }`}
                        onClick={this.addToFeatured.bind(this, "icon")}
                    >
                        <svg viewBox="0 0 100 100" width="42" height="42">
                            <use x="0" y="0" xlinkHref="#star.svg" />
                        </svg>
                    </button>
                    <button
                        type="button"
                        style={{
                            width: "100px",
                            borderRadius: "0",
                            border: "1px solid #ffbf43"
                        }}
                        className={`btn btn-default featured-item featured-collection
                            ${!this.props.icon.collection.id ? "disabled" : ""}
                            ${
                                this.props.icon.feature_collection
                                    ? "active"
                                    : ""
                            }`}
                        onClick={this.addToFeatured.bind(this, "collection")}
                    >
                        <svg viewBox="0 0 100 100" width="42" height="42">
                            <use
                                x="0"
                                y="0"
                                xlinkHref="#favorite_collection.svg"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        );
    }

    saveName(e) {
        let name = this.refs[e.target.name].value;
        this.props.saveName(this.props.icon.id, name);
    }

    saveTag(e) {
        let tags = Object.assign({}, this.props.icon.tags);
        tags[e.target.name] = this.refs[e.target.name].value;

        this.props.saveTags(this.props.icon.id, tags);
    }

    stopCardClick(e) {
        e.stopPropagation();
    }
}

module.exports = connect(null, {
    featureIcon: actions.featureIcon,
    featureCollection: actions.featureCollection,
    unFeatureCollection: actions.unFeatureCollection,
    unFeatureIcon: actions.unFeatureIcon,
    selectIcon: actions.selectIcon,
    saveName: actions.saveName,
    saveTags: actions.saveTags,
    deselectIcon: actions.deselectIcon
})(ModerationIconCard);
